import { createSlice } from "@reduxjs/toolkit";


export const InitialHomeState = {
    hotProductList: [],
    hotCategoriesList: [],
};

const homeSlice = createSlice({
    name: "home",
    initialState: InitialHomeState,
    reducers: {

        setHotProductList(state, { payload }) {
            state.hotProductList = payload;
        },
        addMoreHotProductList(state, { payload }) {
            state.hotProductList = [...state.hotProductList, ...payload]
        },

        setHotCategoriesList(state, { payload }) {
            state.hotCategoriesList = payload;
        },
        addMoreHotCategoriesList(state, { payload }) {
            state.hotCategoriesList = [...state.hotCategoriesList, ...payload]
        },


    }
});


export const homeActions = homeSlice.actions;
export default homeSlice;